import { createStore } from 'zustand'

import { WebOfficeStore } from './interface'

export const createWebOfficeStore = () =>
  createStore<WebOfficeStore>((set, get) => ({
    instance: undefined,
    app: undefined,
    setInstance(instance) {
      set({ instance, app: instance.Application })
    }
  }))
